import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class AssessmentMasterHeaderService {
  private baseUrl = "/api/v1/assessment-master-headers"; // Replace with your Laravel API URL

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  getAllAssessmentMasterHeaders(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}`, { headers });
  }

  getAssessmentMasterHeaderById(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}/${id}`, { headers });
  }

  createAssessmentMasterHeader(data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.baseUrl}`, data, { headers });
  }

  updateAssessmentMasterHeader(id: number, data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(`${this.baseUrl}/${id}`, data, { headers });
  }

  deleteAssessmentMasterHeader(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(`${this.baseUrl}/${id}`, { headers });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/assessment-master-header.service.ts